export const IP = '0.0.0.0';
export const USER_ID = null;
